// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__xjuCr","opacity-transition":"success_opacity-transition__1yZCK"};